import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { StyledCommonProps } from "../../utils/styled";
import {
  IconCautionSolid,
  IconFailureSolid,
  IconInfoSolid,
  IconSuccessSolid,
} from "../icons";
import Spinner from "../utils/Spinner";

export const BannerIcon = styled.div`
  display: block;
  flex-shrink: 0;

  svg {
    display: block;
  }
`;
export const BannerText = styled.div`
  line-height: 1.5em;
  width: 100%;
`;
export const BannerWrapper = styled.div<Props>`
  display: flex;
  align-items: center;
  padding-left: 1rem;
  gap: 2rem;
  padding: 1rem;
  box-sizing: border-box;
  min-height: 3rem;

  ${({ variant = "contained" }) =>
    variant === "contained" &&
    `
      border: solid 1px #ddd;
      border-radius: 0.5rem;
      background-color: #fff;
    `}

  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;

interface Props extends PropsWithChildren<StyledCommonProps> {
  icon?: React.ReactNode;
  variant?: "contained" | "plain";
}

const BannerComponent = (props: Props) => {
  const { className, icon, children, ...otherProps } = props;
  return (
    <div className={className}>
      <BannerWrapper {...otherProps}>
        {icon && <BannerIcon>{icon}</BannerIcon>}
        <BannerText>{children}</BannerText>
      </BannerWrapper>
    </div>
  );
};

export const Banner = styled(BannerComponent)``;

const CautionBannerComponent: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <Banner {...props} icon={<IconCautionSolid />} variant="plain">
      {props.children}
    </Banner>
  );
};
export const CautionBanner = styled(CautionBannerComponent)`
  & ${BannerIcon} {
    fill: #f6b723;
    width: 24px;
  }
`;

const SuccessBannerComponent: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <Banner {...props} icon={<IconSuccessSolid />} variant="plain">
      {props.children}
    </Banner>
  );
};
export const SuccessBanner = styled(SuccessBannerComponent)`
  & ${BannerIcon} {
    fill: #3ca53c;
    width: 24px;
  }
`;

const FailureBannerComponent: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <Banner {...props} icon={<IconFailureSolid />} variant="plain">
      {props.children}
    </Banner>
  );
};
export const FailureBanner = styled(FailureBannerComponent)`
  & ${BannerIcon} {
    fill: #ee5f5f;
    width: 24px;
  }
`;

const InfoBannerComponent: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <Banner {...props} icon={<IconInfoSolid />} variant="plain">
      {props.children}
    </Banner>
  );
};
export const InfoBanner = styled(InfoBannerComponent)`
  & ${BannerIcon} {
    fill: #7567d2;
    width: 24px;
  }
`;

const SpinnerBannerComponent: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <Banner {...props} icon={<Spinner />} variant="plain">
      {props.children}
    </Banner>
  );
};
export const SpinnerBanner = styled(SpinnerBannerComponent)`
  & ${BannerIcon} {
    fill: #7567d2;
    width: 24px;
  }
`;
